import { apiBaseUrl } from 'app/src/msw/commonconfig'
import type { tutorialsApi } from 'app/src/services/welfareportal'
import { DefaultBodyType, http, HttpResponse } from 'msw'
import { mockTutorials } from './mocktutorials'

export const getTutorialsPaginated = http.get<object, DefaultBodyType, tutorialsApi.TutorialsPaginated>(
  apiBaseUrl + '/tutorials',
  async ({ request }) => {
    const url = new URL(request.url)

    const offset = Number.parseInt(url.searchParams.get('pagingOffset') ?? '0', 10)
    const limit = Number.parseInt(url.searchParams.get('pagingLimit') ?? `${mockTutorials.length}`, 10)

    const slicedItems = mockTutorials.slice(offset, offset + limit).map((item) => ({
      ...item,
      title: `${item.title} - ${item.id}`,
    }))

    return HttpResponse.json({
      items: slicedItems,
      paging: {
        limit,
        offset,
        total: mockTutorials.length,
      },
    })
  },
)

export const tutorialsHandlers = [getTutorialsPaginated]
